import { React } from 'react';
import { Form, Button, Stack } from 'react-bootstrap';
import * as api from 'services/api';
import './EquipmentsSearcher.css';
import { useTranslation } from 'react-i18next';
export function EquipmentsSearcher({ equipmentData, setEquipmentData, equipmentIdentDisabled, setEquipmentIdentDisabled, equipmentFound, setEquipmentFound, disableCleanButt, setInterventionType }) {
  const { t } = useTranslation();
  // Controlar que no se puedan meter más de 12 caracteres en el input, porque sino da error
  const handleKeyDown = (event) => {
    if (event.target.value.length >= 12 && event.keyCode !== 8) {
      event.preventDefault();
    }
  };
  
  const handleEquipmentIdentChange = (event) => {
    setEquipmentData((data) => ({ 
      ...data, 
      equipmentIdent: event.target.value, 
      equipmentType: false 
    }));
  };

  const handleClear = () => {
    setEquipmentData((data) => ({ 
      ...data, 
      equipmentIdent: '' 
    }));
    setEquipmentFound(null);
      setEquipmentIdentDisabled(false);
      setInterventionType({
          id: 0
      })
  };

  const handleSearchEquipment = async (event) => {
    event.preventDefault();

    try {
      const response = await api.getEquipment(equipmentData.equipmentIdent);

      if (response.status === 200) {
       
        const { epecLocationId, equipmentTelephone, otherTelephone, telephone3 } = response.data;
        setEquipmentData((data) => ({ ...data, epecLocationId, equipmentTelephone, otherTelephone, telephone3 }));
        setEquipmentFound(true);  
      } else {
        setEquipmentFound(false);
      }

      setEquipmentIdentDisabled(true);
    } catch (error) {
      console.error('Error en la conexión');
    }
  };
  
  return (
    <div className="EquipmentsSearcher mb-3">
      <Form className="mt-5" onSubmit={handleSearchEquipment}>
        <Stack direction="horizontal" gap="4">
          <Form.Control 
            type="number" 
            placeholder={t('eSearchNiu')} 
            className="EquipmentsSearcher__input bg-light" 
            value={equipmentData.equipmentIdent} 
            disabled={equipmentIdentDisabled} 
            onKeyDown={handleKeyDown}
            onChange={handleEquipmentIdentChange} 
          />
          <Stack direction="horizontal" gap="2">
            <Button type="submit" variant="dark" disabled={!equipmentData.equipmentIdent || equipmentData.equipmentType }>{t('eSearchSearch')} </Button>
            <Button variant="outline-dark" disabled={disableCleanButt} onClick={handleClear}>{t('eSearchClear')} </Button>
          </Stack>
        </Stack>
      </Form>
      <div className="mt-3">
        {equipmentFound === false && <p>{t('eSearchNotFound')} </p>}
      </div>
    </div>
  );
}